(function () {
  if (typeof window === 'undefined') {
    return;
  }

  const global = window;
  global.dataLayer = global.dataLayer || [];

  const SESSION_STORAGE_KEY = 'fc_analytics_session_id';
  const PAGE_LOAD_ID = `fc_${Date.now()}_${Math.random().toString(36).slice(2, 10)}`;
  let sessionId;

  try {
    sessionId = global.sessionStorage.getItem(SESSION_STORAGE_KEY);
    if (!sessionId) {
      sessionId = `sess_${Date.now()}_${Math.random().toString(36).slice(2, 10)}`;
      global.sessionStorage.setItem(SESSION_STORAGE_KEY, sessionId);
    }
  } catch (error) {
    sessionId = `sess_${Date.now()}_${Math.random().toString(36).slice(2, 10)}`;
  }

  let context = global.fcAnalyticsContext || {};
  let queue = [];
  let flushing = false;

  function flushQueue() {
    if (flushing) return;
    flushing = true;

    try {
      while (queue.length) {
        global.dataLayer.push(queue.shift());
      }
    } finally {
      flushing = false;
    }
  }

  function scheduleFlush() {
    if (document.readyState === 'complete' || document.readyState === 'interactive') {
      flushQueue();
    } else {
      document.addEventListener('DOMContentLoaded', flushQueue, { once: true });
    }
  }

  function buildEventObject(eventName, payload) {
    const baseContext = {
      event: eventName,
      event_origin: 'theme',
      event_time: new Date().toISOString(),
      page_location: global.location.href,
      page_path: global.location.pathname,
      page_referrer: document.referrer || null,
      page_title: document.title,
      session_id: sessionId,
      page_load_id: PAGE_LOAD_ID
    };

    return Object.assign({}, baseContext, context, payload);
  }

  const analytics = {
    push(eventName, payload = {}) {
      if (!eventName) return;

      const eventObject = buildEventObject(eventName, payload);

      if (!global.dataLayer) {
        queue.push(eventObject);
        scheduleFlush();
        return;
      }

      if (queue.length) {
        flushQueue();
      }

      global.dataLayer.push(eventObject);
    },

    setContext(partialContext = {}) {
      if (!partialContext || typeof partialContext !== 'object') return;
      context = Object.assign({}, context, partialContext);
    },

    getContext() {
      return Object.assign({}, context);
    }
  };

  if (!global.fcAnalytics) {
    global.fcAnalytics = analytics;
  } else {
    // Merge into existing analytics helper if present
    global.fcAnalytics.setContext(context);
  }

  flushQueue();
})();
